{
  "version": 1,
  "asset_id": "e75d8700-b850-48b8-b8ee-0f5cc15f4672",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/e75d8700-b850-48b8-b8ee-0f5cc15f4672/gallery-11.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/e75d8700-b850-48b8-b8ee-0f5cc15f4672/gallery-11.jpeg",
  "original_filename": "gallery-11.jpeg",
  "size": 2714397,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:23:03Z"
}
